// extracted by mini-css-extract-plugin
export default {"button__download":"downloadButton_button__download__f6qIm","button__download_text":"downloadButton_button__download_text__ej4Aa"};